module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAXBAMAAAASBMmTAAAAAXNSR0IArs4c6QAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAd0SU1FB90CHAQKJMOeupEAAAAZdEVYdENvbW1lbnQAQ3JlYXRlZCB3aXRoIEdJTVBXgQ4XAAAAFVBMVEUAAAAAAAFYOgyzOQO0qwbdTwH////oPAW1AAAAAXRSTlMAQObYZgAAAAFiS0dEBmFmuH0AAACQSURBVBjTTY6BDcQgDAPTDeKKHwBWqDoAEhngBey/Sm36rd6KkM8mCDPJ7U94HWP4U8K2hKeEb62qpBhvUVUKWk3RwFIQNc2BWMC49dGiaYmxYA7XSh9xnDyrVo5zHud44R5B6t/UBzgEBPKHUxdgL7kUQF8QlEzvq3nIjIZXiuQLCvYXdAULcHtS9vXAT3YBcRUeSEMH/OgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./assets/icons/firemaking-icon.png
// module id = 490
// module chunks = 0